import { createFileRoute, Link } from '@tanstack/react-router';
import { StatusBadge } from '../components/StatusBadge.js';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card.js';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table.js';
import { requireRole } from '../lib/auth-guard.js';
import { trpc } from '../lib/trpc.js';

export const Route = createFileRoute('/client/assignments')({
  component: ClientAssignments,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['client']);
  },
});

function ClientAssignments() {
  const list = trpc.assignments.listMineAsClient.useQuery();

  return (
    <div className="min-h-screen p-6 max-w-4xl mx-auto space-y-6">
      <Link to="/client" className="text-sm text-[var(--muted-foreground)] hover:text-foreground">
        ← Zurück zur Übersicht
      </Link>
      <h1 className="text-3xl font-bold">Meine Einsätze</h1>

      <Card>
        <CardHeader>
          <CardTitle>Überlassene Mitarbeiter</CardTitle>
          <CardDescription>Aktuelle und vergangene Einsätze in Ihrem Betrieb</CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Mitarbeiter</TableHead>
                <TableHead>Tätigkeit</TableHead>
                <TableHead>Zeitraum</TableHead>
                <TableHead>Einsatzort</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {list.isLoading && (
                <TableRow>
                  <TableCell colSpan={5} className="text-[var(--muted-foreground)]">
                    Lade …
                  </TableCell>
                </TableRow>
              )}
              {list.data?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className="text-[var(--muted-foreground)]">
                    Keine Einsätze.
                  </TableCell>
                </TableRow>
              )}
              {list.data?.map((a) => (
                <TableRow key={a.id}>
                  <TableCell>
                    {[a.workerFirstName, a.workerLastName].filter(Boolean).join(' ') ||
                      '(unbenannt)'}
                  </TableCell>
                  <TableCell>{a.roleDescription ?? '—'}</TableCell>
                  <TableCell className="text-[var(--muted-foreground)]">
                    {a.startDate ?? '?'} – {a.endDate ?? 'offen'}
                  </TableCell>
                  <TableCell className="text-[var(--muted-foreground)]">
                    {a.worksiteAddress ?? '—'}
                  </TableCell>
                  <TableCell>
                    <StatusBadge status={a.status} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
